import { Route } from 'config/routes';
import { createSelector } from 'reselect';
import { searchBulletinsSelector, searchCommercialBulletinsSelector } from 'store/state/domainData/selectors';
import { marketplaceSelector, routeSelector } from 'store/state/selectors/router';
import { MarketplaceType } from 'utils/entities';

const EMPLOYMENT_AREA_PAGE_LISTINGS_LIMIT = 35;

export const searchBulletinsByMarketplaceSelector = createSelector([
  marketplaceSelector,
  routeSelector,
  searchBulletinsSelector,
  searchCommercialBulletinsSelector,
], (marketplace, route, bulletins, commercialBulletins) => {
  if (marketplace === MarketplaceType.Residential) return bulletins;

  if (route.name === Route.EmploymentAreaPage && commercialBulletins && commercialBulletins.length > EMPLOYMENT_AREA_PAGE_LISTINGS_LIMIT) {
    commercialBulletins = commercialBulletins.slice(0, EMPLOYMENT_AREA_PAGE_LISTINGS_LIMIT);
  }

  return commercialBulletins;
});
